import React from "react";
import { useNavigate } from "react-router-dom";

function formatInt(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return new Intl.NumberFormat("ru-RU").format(Math.max(0, Math.floor(n)));
}

export default function SubscriptionLimitModal({
  open = false,
  title = "",
  action = "",
  used = 0,
  limit = 0,
  nextPlanName = "тариф выше",
  onClose,
}) {
  const navigate = useNavigate();
  if (!open) return null;

  return (
    <div className="sub-limit-modal__overlay" role="presentation" onClick={onClose}>
      <div
        className="sub-limit-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Ограничение тарифа"
        onClick={(event) => event.stopPropagation()}
      >
        <button type="button" className="sub-limit-modal__close" onClick={onClose} aria-label="Закрыть">
          ×
        </button>

        <div className="sub-limit-modal__badge">Лимит тарифа</div>
        <h3 className="sub-limit-modal__title">Вы достигли лимита</h3>
        <p className="sub-limit-modal__text">
          По вашему тарифу достигнут лимит для раздела <strong>{title}</strong>: {formatInt(used)} из {formatInt(limit)}.
        </p>
        <p className="sub-limit-modal__text">
          Перейдите на <strong>{nextPlanName}</strong>, чтобы снять ограничение и продолжить {action}.
        </p>

        <div className="sub-limit-modal__actions">
          <button type="button" className="sub-limit-modal__btn sub-limit-modal__btn--ghost" onClick={onClose}>
            Позже
          </button>
          <button
            type="button"
            className="sub-limit-modal__btn sub-limit-modal__btn--mint"
            onClick={() => navigate("/dashboard/subscription")}
          >
            Перейти к тарифам →
          </button>
        </div>
      </div>
    </div>
  );
}

